import Util from "@/Master/Util";
// import { EventEmitter } from 'events';
// // 触发导航事件
// eventBus.emit('navigate', '/home');


/**
 * 事件管理器类，用于统一管理自定义事件的添加、触发和移除。
 */
export default class EventManager {
    /**
     * 全局的 EventTarget 实例，用于事件的分发和监听。
     */
    static eventTarget: EventTarget = new EventTarget();

    /**
     * 存储所有已添加的事件监听器，便于统一管理和移除。
     */
    static eventListeners: Array<{ eventName: string; callback: EventListener }> = [];

    /**
     * 触发指定名称的事件，并可附带详细数据。
     * @param eventName - 事件的名称。
     * @param detail - 事件的详细数据，默认为空对象。
     */
    static dispatchEvent(eventName: string, detail: any = {}): void {
        const event = new CustomEvent(eventName, { detail });
        EventManager.eventTarget.dispatchEvent(event);
    }

    /**
     * 添加事件监听器，并将其记录在 eventListeners 数组中。
     * @param eventName - 事件的名称。
     * @param callback - 事件触发时的回调函数。
     */
    static addEventListener(eventName: string, callback: EventListener): void {
        EventManager.eventTarget.addEventListener(eventName, callback);
        EventManager.eventListeners.push({ eventName, callback });

        if (Util.isLog) {
            console.log('EventManager', EventManager.eventListeners);
        }
    }

    /**
     * 移除指定的事件监听器。
     * @param eventName - 事件的名称。
     * @param callback - 要移除的回调函数。
     */
    static removeEventListener(eventName: string, callback: EventListener): void {
        EventManager.eventTarget.removeEventListener(eventName, callback);
        // 从 eventListeners 数组中移除对应的监听器
        EventManager.eventListeners = EventManager.eventListeners.filter(
            listener => !(listener.eventName === eventName && listener.callback === callback)
        );

        if (Util.isLog) {
            console.log('EventManager after removal', EventManager.eventListeners);
        }
    }

    /**
     * 移除所有已添加的事件监听器，并清空 eventListeners 数组。
     */
    static removeAllListeners(): void {
        EventManager.eventListeners.forEach(({ eventName, callback }) => {
            EventManager.removeEventListener(eventName, callback);
        });
        EventManager.eventListeners.length = 0; // 清空事件监听器数组

        if (Util.isLog) {
            console.log('EventManager', EventManager.eventListeners);
        }
    }
}
